import { useTranslation } from 'react-i18next';

const advantages = [
  { icon: 'ri-check-line', key: 'trust_no_deposit_detail' },
  { icon: 'ri-check-line', key: 'trust_pay_on_site' },
  { icon: 'ri-check-line', key: 'trust_english_guides' },
  { icon: 'ri-check-line', key: 'trust_private_detail' },
  { icon: 'ri-check-line', key: 'trust_transparent_detail' },
  { icon: 'ri-check-line', key: 'trust_support' },
];

export default function WhyYallabinaSection() {
  const { t, i18n } = useTranslation();

  return (
    <section className="relative bg-primary-950 py-16 md:py-20 lg:py-24 overflow-hidden">
      {/* Subtle top border accent */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-accent-400/30 to-transparent" />

      {/* Background texture dots */}
      <div className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: 'radial-gradient(circle, rgba(212,175,55,0.8) 1px, transparent 1px)',
          backgroundSize: '32px 32px',
        }}
      />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-12 xl:px-20">
        <div className="flex flex-col lg:flex-row items-stretch gap-10 lg:gap-14 xl:gap-20">
          {/* Left Column — Image */}
          <div className="w-full lg:w-[48%] flex-shrink-0">
            <div className="relative rounded-xl overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.35)]">
              <img
                src="https://public.readdy.ai/ai/img_res/edited_eda3200c9250c00e23c8d6b4eb357a9c_9d00426f.jpg"
                alt="Gäste mit Yallabina Tourguide bei den Pyramiden von Gizeh"
                className="w-full h-[360px] md:h-[440px] lg:h-[520px] object-cover object-center rounded-xl"
                loading="lazy"
              />
              {/* Subtle gold frame accent */}
              <div className="absolute inset-0 rounded-xl border border-accent-400/15 pointer-events-none" />
              {/* Bottom gradient fade for depth */}
              <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-primary-950/60 to-transparent pointer-events-none" />
              {/* Gold Experience Badge */}
              <div className="absolute top-5 left-5 flex items-center gap-2.5 pl-3.5 pr-5 py-2.5 bg-accent-500/85 backdrop-blur-md text-primary-950 text-xs md:text-sm font-bold rounded-lg whitespace-nowrap shadow-[0_4px_20px_rgba(0,0,0,0.45)] border border-accent-400/25">
                <div className="w-6 h-6 md:w-7 md:h-7 flex items-center justify-center">
                  <i className="ri-award-fill text-primary-950 text-base md:text-xl" />
                </div>
                <span>{t('trust_experience')}</span>
              </div>
            </div>
          </div>

          {/* Right Column — Content */}
          <div className="w-full lg:w-[52%] flex flex-col justify-center">
            {/* Section Label */}
            <p className="text-accent-400 text-xs md:text-sm font-medium tracking-[0.3em] uppercase mb-4">
              Yallabina Tours
            </p>

            {/* Title */}
            <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl font-bold text-background-50 mb-4 md:mb-5 leading-[1.15] tracking-tight">
  {t('trust_title')}
            </h2>

            {/* Subtitle */}
            <p className="text-background-200 text-sm md:text-base leading-relaxed mb-8 md:mb-10 max-w-lg">
              {t('trust_subtitle')}
            </p>

            {/* Advantages Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4 md:gap-y-5 mb-6 md:mb-8">
              {advantages.map((adv) => (
                <div
                  key={t(adv.key === 'trust_english_guides' ? (i18n.language === 'de' ? 'trust_german_guides' : 'trust_english_guides') : adv.key)}
                  className="flex items-start gap-3 group"
                >
                  <div className="w-5 h-5 md:w-6 md:h-6 flex-shrink-0 flex items-center justify-center mt-0.5 rounded-full bg-accent-400/10 border border-accent-400/20 group-hover:bg-accent-400/20 group-hover:border-accent-400/40 transition-all duration-300">
                    <i className={`${adv.icon} text-accent-400 text-xs md:text-sm`} />
                  </div>
                  <span className="text-background-200 text-sm md:text-base leading-snug group-hover:text-background-50 transition-colors duration-300">
  {t(adv.key === 'trust_english_guides' ? (i18n.language === 'de' ? 'trust_german_guides' : 'trust_english_guides') : adv.key)}
                  </span>
                </div>
              ))}
            </div>

            {/* CTA Button */}
            <a
              href="https://wa.me/201000932585"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-3 self-start px-9 py-3.5 md:px-11 md:py-4 bg-accent-500 text-primary-950 text-sm md:text-base font-semibold rounded-sm hover:bg-accent-400 transition-all duration-300 cursor-pointer whitespace-nowrap uppercase tracking-wider shadow-[0_6px_24px_rgba(212,175,55,0.2)] hover:shadow-[0_10px_36px_rgba(212,175,55,0.35)]"
            >
              <span>{t('contact_cta')}</span>
              <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform duration-300" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}